'use strict'

document.addEventListener('DOMContentLoaded', () => {
  /********************************
   * Vars
   *******************************/
  const html = document.querySelector('html');
  const body = document.querySelector('body');

  /********************************
   * Klaviyo Form
   *******************************/
  const klaviyoFormGroup = document.querySelectorAll('.klaviyo-form');

  if (klaviyoFormGroup.length) {
    function submitKlaviyoForm(e, listId, companyId, klaviyoForm, klaviyoFormError, klaviyoFormSuccessful) {
      e.preventDefault();
      const emailInput = klaviyoForm.querySelector('.input-email');
      if (!emailInput.value) return;

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + companyId, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'revision': '2024-07-15'
        },
        body: JSON.stringify({
          data: {
            type: "subscription",
            attributes: {
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: emailInput.value,
                  }
                }
              }
            },
            relationships: {
              list: {
                data: {
                  type: "list",
                  id: listId
                }
              }
            }
          }
        })
      })
      .then(function (response) {
        return response.text();
      })
      .then(function (data) {
        console.log(`data, ${data}`);
        emailInput.value = '';
        klaviyoFormSuccessful.style.display = 'block'
      })
      .catch(function (error) {
        console.error('Error:', error);
        klaviyoFormError.style.display = 'block'
      });
    }

    klaviyoFormGroup.forEach(klaviyoFormItem =>{
      const listId = klaviyoFormItem.dataset.list;
      const companyId = klaviyoFormItem.dataset.companyId;
      const klaviyoForm = klaviyoFormItem.querySelector('form');
      const klaviyoFormError = klaviyoFormItem.querySelector('.subscribe-error');
      const klaviyoFormSuccessful = klaviyoFormItem.querySelector('.subscribe-successful');

      klaviyoForm.addEventListener('submit', (e) => submitKlaviyoForm(e, listId, companyId, klaviyoForm, klaviyoFormError, klaviyoFormSuccessful));
    });
  }

});